/**
 * Portal Entry Point for Workforce Attendance
 *
 * This file registers all pages with the portal system.
 * It is imported by the portal's virtual:portal-entries module.
 */

import { registerPage } from "@ja/portal/pageRegistry";

// Admin pages
registerPage(
    "attendance",
    "Admin/AttendanceDashboard",
    () => import("./Pages/Admin/AttendanceDashboard.vue")
);
